import React, {useMemo} from 'react';
import type {IconName} from 'components/icons/types';
import {useLocalization} from 'localization';
import type {BaseColorName} from 'theme';
import {ActionButton} from 'components';
import type {SelectAction} from '../../editThesaurus/types';

type Props = {
  nodeId: string;
  action: SelectAction | undefined;
  addNodeId: (nodeId: string) => void;
  removeNodeId: (nodeId: string) => void;
};

export const SearchMatchAction: React.FC<Props> = ({
  nodeId,
  action,
  addNodeId,
  removeNodeId,
}) => {
  const {tLoose} = useLocalization();
  const {actionTitle, actionIcon, actionBackground, onAction} = useMemo(() => {
    const actionType = action?.type ?? 'select';
    const actionTitle = tLoose(`extension.thesaurusEdit.${actionType}`);
    const actionIcon: IconName =
      actionType === 'select'
        ? 'Check'
        : actionType === 'swap'
          ? 'Swap'
          : 'Remove';
    const actionBackground: BaseColorName =
      actionType === 'select' ? 'brown' : 'offWhite';
    return {
      nodeId,
      actionTitle,
      actionIcon,
      actionBackground,
      onAction: () =>
        actionType === 'remove' ? removeNodeId(nodeId) : addNodeId(nodeId),
    };
  }, [action?.type, addNodeId, nodeId, removeNodeId, tLoose]);

  return (
    <ActionButton
      title={actionTitle}
      icon={actionIcon}
      size="small"
      background={actionBackground}
      showSpinnerOnClick
      onClick={onAction}
      data-cy={'button-thesaurus-picker'}
    />
  );
};
